import { createFileRoute } from "@tanstack/react-router";

import ResetPasswordSuccess from "@/features/auth/ResetPasswordSuccess";
import BasicLayout from "@/layouts/Basic";

export const Route = createFileRoute("/reset-password-success")({
  component: () => (
    <BasicLayout>
      <ResetPasswordSuccess />
    </BasicLayout>
  ),
});
